import { definePreset } from '@primevue/themes'
import Lara from '@primevue/themes/lara'

const asknicelyPreset = definePreset(Lara, {
    semantic: {
        primary: {
            50: '{violet.50}',
            100: '#F9F5FF',
            200: '#E9D7FE',
            300: '#D6BBFB',
            400: '{violet.400}',
            500: '#7F56D9',
            600: '#6941C6',
            700: '{violet.700}',
            800: '{violet.800}',
            900: '{violet.900}',
            950: '{violet.950}',
        },
        gray: {
            25: '#FCFCFD',
            50: '#F9FAFB',
            100: '#F2F4F7',
            200: '#EAECF0',
            300: '#D0D5DD',
            400: '#98A2B3',
            500: '#667085',
            600: '#475467',
            700: '#344054',
            800: '#182230',
            900: '#101828',
            950: '#0C111D',
        },
        success: {
            25: '#F6FEF9',
            50: '#ECFDF3',
            100: '#DCFAE6',
            200: '#ABEFC6',
            300: '#75E0A7',
            400: '#47CD89',
            500: '#17B26A',
            600: '#079455',
            700: '#067647',
            800: '#085D3A',
            900: '#074D31',
            950: '#053321',
        },
        error: {
            25: '#FFFBFA',
            50: '#FEF3F2',
            100: '#FEE4E2',
            200: '#FECDCA',
            300: '#FDA29B',
            400: '#F97066',
            500: '#F04438',
            600: '#D92D20',
            700: '#B42318',
            800: '#912018',
            900: '#7A271A',
            950: '#55160C',
        },
        warning: {
            25: '#FFFCF5',
            50: '#FFFAEB',
            100: '#FEF0C7',
            200: '#FEDF89',
            300: '#FEC84B',
            400: '#FDB022',
            500: '#F79009',
            600: '#DC6803',
            700: '#B54708',
            800: '#93370D',
            900: '#7A2E0E',
            950: '#4E1D09',
        },
        indigo: {
            50: '#EEF4FF',
            100: '#E0EAFF',
            200: '#C7D7FE',
            300: '#A4BCFD',
            400: '#8098F9',
            500: '#6172F3',
            600: '#444CE7',
            700: '#3538CD',
        },
    },
})

export const PrimeVuePreset = {
    theme: {
        preset: asknicelyPreset,
        options: {
            darkModeSelector: 'none',
            cssLayer: {
                name: 'primevue',
            },
        },
    },
    ripple: true,
}

export default PrimeVuePreset
